import {Components} from "@mui/material/styles/components";

export default function Container(): Components {
  return {
    MuiContainer: {
      defaultProps: {
        maxWidth: false,
      },
      styleOverrides: {
        root: {},
      },
    },
  };
}
